import { Box, Button } from "@mui/material";
import { FC } from 'react';

interface EventActionButtonsProps {
    eventId: string;
    onCancel: () => void;
}

const EventActionButtons: FC<EventActionButtonsProps> = ({ eventId, onCancel }) => {
    return (
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>
            <Button
                variant='contained'
                onClick={onCancel}
                size="large"
            >
                Cancel
            </Button>
            <Button
                variant='contained'
                type='submit'
                size="large"
            >
                {eventId.toLowerCase() === 'new' ? 'Create Event' : 'Save Changes'}
            </Button>
        </Box>
    );
};

export default EventActionButtons;
